import { MajorServiceClassification } from './major-service-classification';

export class CompSearchReCycleSearchRead {
  compSearchId: number;
  numCompsInPool: number;
  numCompsInPoolWithDiscards: number;
  isCompPoolAllowed: boolean;
  primaryFunctionId: number;
  minIndustrialCodeRange: number;
  maxIndustrialCodeRange: number;
  locationId: number;
  locationTypeId: number;
  runOnDate: string;
  locations: {
    name: string,
    locationTypeId: number,
    locationId: number,
    preference: number,
  }[];
  majorClassifications: MajorServiceClassification[];
}
